import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';

import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgToastService } from 'ng-angular-popup';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { Router } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { ApplicantPqqSectionsComponent } from '../applicant-pqq-sections.component';
import { environment } from '@/app/environments/environment';
import { GetFileIconUtilityService } from '@/app/services/utility/get-file-icon-utility.service';
@Component({
  standalone: true,
  imports: [
    MatExpansionModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatRadioModule,
  ],
  selector: 'app-legal-compliance',
  templateUrl: './legal-compliance.component.html',
  styleUrls: ['./legal-compliance.component.css'],
})
export class LegalComplianceComponent implements OnInit, OnChanges {
  @Input() applicantData: any;
  @Input() isEdit: boolean;
  formGroup: FormGroup;
  base_path = environment.storageUrl;
  ethicalPracticesAttachMents: any[] = [];
  oldEthicalPracticesAttachMents: any[] = [];
  deletedOldEthicalPracticesFilesIds: any[] = [];
  @Input() isFetchApplicantData: boolean;

  constructor(
    private fb: FormBuilder,
    private toast: NgToastService,
    private projectsService: ProjectsService,
    private router: Router,
    private ApplicantPqqSectionsComponent: ApplicantPqqSectionsComponent,
    private getFileIconService: GetFileIconUtilityService
  ) {}

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      // Compliance and Legal Information
      has_prosecutions: ['0'],
      has_current_legal_dispute: ['0'],
      current_legal_dispute_details: [''],
      confirm_business_practices: ['0'],
    });

    if (this.isEdit) {
      this.patchFormValues();
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['isFetchApplicantData'] &&
      !changes['isFetchApplicantData'].firstChange
    ) {
      this.patchFormValues();
    }
  }
  patchFormValues() {
    this.formGroup.patchValue({
      has_prosecutions: String(this.applicantData?.has_prosecutions) || '0',
      has_current_legal_dispute:
        String(this.applicantData?.has_current_legal_dispute) || '0',
      current_legal_dispute_details:
        this.applicantData?.current_legal_dispute_details || '',
      confirm_business_practices:
        String(this.applicantData?.confirm_business_practices) || '0',
    });
    this.oldEthicalPracticesAttachMents =
      this.applicantData?.parent_document.filter(
        (doc) => doc.type === 'ethical_practices_accreditations_attach'
      ) || [];
  }

  onFileUpload(event: any, name: string) {
    const files = event.target.files;

    if (name === 'ethical_practices_attach') {
      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          this.ethicalPracticesAttachMents.push(files[i]);
        }
      }
    }
  }

  removeNewFile(index: number, name: string) {
    if (name === 'ethical_practices_attach') {
      if (
        this.ethicalPracticesAttachMents &&
        this.ethicalPracticesAttachMents.length > index
      ) {
        this.ethicalPracticesAttachMents.splice(index, 1);
      }
    }
  }

  removeOldFile(index: number, id: number, name: string) {
    if (name === 'ethical_practices_attach') {
      if (
        this.oldEthicalPracticesAttachMents &&
        this.oldEthicalPracticesAttachMents.length > index
      ) {
        this.oldEthicalPracticesAttachMents.splice(index, 1);
        this.deletedOldEthicalPracticesFilesIds.push(id);
      }
    }
  }

  openPdf(imageSrc: string): void {
    window.open(imageSrc, '_blank');
  }

  isImageFile(file: any) {
    // console.log('The file value is:', file);
    // List of image file extensions
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    let fileExtension: any;
    // Extract the file extension from the file's name (not from preview)
    if (this.isEdit && !file?.name) {
      fileExtension = file?.split('.').pop()?.toLowerCase();
    } else if (this.isEdit && file?.name) {
      fileExtension = file?.name?.split('.').pop()?.toLowerCase();
    } else {
      fileExtension = file?.name?.split('.').pop()?.toLowerCase();
    }

    // Check if the extension is in the list of image extensions
    return imageExtensions.includes(fileExtension || '');
  }

  handleBack() {
    this.ApplicantPqqSectionsComponent.previousStep();
  }

  prepareDataToSubmit() {
    const dataToSubmit = new FormData();

    // Dynamically append all form controls to FormData
    Object.keys(this.formGroup.controls).forEach((key) => {
      const value = this.formGroup.get(key)?.value;
      if (value !== null && value !== undefined && value !== '') {
        dataToSubmit.append(key, value);
      }
    });

    if (this.ethicalPracticesAttachMents?.length) {
      this.ethicalPracticesAttachMents.forEach((file: File) => {
        dataToSubmit.append('ethical_practices_accreditations_attach[]', file);
      });
    }
    if (this.deletedOldEthicalPracticesFilesIds?.length > 0) {
      dataToSubmit.append(
        'deleted_ethical_practices_attach_ids',
        JSON.stringify(this.deletedOldEthicalPracticesFilesIds)
      );
    }

    dataToSubmit.append('is_update', this.isEdit ? 'true' : 'false');

    return dataToSubmit;
  }

  onSubmit(): void {
    if (this.formGroup.valid) {
      const dataToSubmit = this.prepareDataToSubmit();
      this.projectsService.projectPQQResponseStep6(dataToSubmit).subscribe({
        next: () => {
          this.toast.success('Pre Qualification submitted', 'SUCCESS');
          this.ApplicantPqqSectionsComponent.nextStep();
        },
        error: (error: any) => {
          console.error('Failed to submit:', error);
          this.toast.danger(error.error.message, 'DANGER', 4000);
        },
      });
    } else {
      this.toast.warning('Please fill the required fields', 'WARNING');
      this.formGroup.markAllAsTouched(); // Highlights all invalid fields
    }
  }
  getFileIcon(file: {
    file: File;
    preview: string;
    id?: number;
    name?: string;
  }): string {
    return this.getFileIconService.getFileIcon(file);
  }
}
